import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const filterGroupUrl =  Menu.CONTENT_FILTERGROUP_URL + '/'

export const onRefresh = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.ADD_FILTER_GROUP_TAG))
  .filter(() => history.location.pathname.startsWith(filterGroupUrl))
  .map(() => Actions.fetchFilterGroup(
    store.getState().app.selectedCommunity,
    store.getState().filterGroup.data.filter.id))

export const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(filterGroupUrl))
  .map((action: Router.OnEnterAction) => Actions.fetchFilterGroup(
    store.getState().app.selectedCommunity,
    action.params.filterGroupId))

const fetchFilterGroups = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(
    App.SELECT_COMMUNITY,
    Request.successConstant(Constants.SOURCE_ADD_FILTER_GROUP),
    Request.successConstant(Constants.ADD_FILTERS))
  .map(() => Actions.fetchFilterGroups(store.getState().app.selectedCommunity))

export const epic = ReduxObservable.combineEpics(
  fetchFilterGroups,
  onEnter,
  onRefresh,
  Flash.createFlashSuccessEpic(Constants.ADD_FILTER_GROUP_TAG, 'Tags added'),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_FILTER_GROUP_TAG, Actions.updateStatus),
)



// WEBPACK FOOTER //
// ./src/pages/filter-group/epic.ts